// extracted by mini-css-extract-plugin
export default {"flexContent":"thDi6","inGui":"mwyLJ"};